import React, { useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { SankeyController, Flow } from 'chartjs-chart-sankey';

Chart.register(...registerables, SankeyController, Flow);

const SankeyDiagram = ({ data }: { data: { nodes: string[]; links: { source: string; target: string; value: number }[] } }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const ctx = canvasRef.current?.getContext('2d');
        if (!ctx) return;

        // サンキーダイアグラムのデータを設定
        const chartData = {
            datasets: [
                {
                    label: 'Sankey Diagram',
                    data: data.links.map(link => ({
                        from: link.source,
                        to: link.target,
                        flow: link.value,
                    })),
                    colorFrom: () => 'blue',
                    colorTo: () => 'green',
                    colorMode: "gradient" as "gradient",
                    /*
                    priority: data.nodes.reduce((acc, node) => {
                        if (node.includes('¥C')) {
                            acc[node] = 0.5; // 中間ノードを中央に配置
                        }
                        if (node.includes('¥B')) {
                            acc[node] = 1; // 中間ノードを中央に配置
                        }
                        if (node.includes('¥A')) {
                            acc[node] = 2; // 中間ノードを中央に配置
                        }
                        return acc;
                    }, {} as Record<string, number>),
*/
                    column: data.nodes.reduce((acc, node) => {
                        if (node.includes('¥C')) {
                            acc[node] = 1; // 中間ノードを中央に配置
                        }
                        
                        return acc;
                    }, {} as Record<string, number>),
                },
            ],
            labels: data.nodes.map(node => node.split('¥')[0]), // 一意の識別子を除外
            
        };

        // チャートを描画
        const chart = new Chart(ctx, {
            type: 'sankey',
            data: chartData,
            options: {
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: context => {
                                const { from, to, flow } = context.raw as { from: string; to: string; flow: number };
                                return `${from.split('¥')[0]} → ${to.split('¥')[0]}: ${flow}`; // 一意の識別子を除外
                            },
                        },
                    },
                },
            },
        });

        return () => {
            chart.destroy();
        };
    }, [data]);

    return <canvas ref={canvasRef} width={800} height={600}></canvas>;
};

export default SankeyDiagram;